/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-08-06 20:15:36
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2020-11-16 13:27:28
 * @Description: file content
 */
import Cookies from "js-cookie";
// 在url后面加参数debug=true开启本地调试
let isDebug = false;
const isLoc = location.host.indexOf("localhost") > -1; //本地环境
const hdkXcxAppId = "62d461e0ade24ac5b8543f8de9da1452"; //很多客小程序appid

const DOMAIN = location.host;
// let API_DOMAIN = "qmyx.huafacrm.com";
let API_DOMAIN = "qmyx.ttrushi.com";

const FAKE_DATA = {
  // 小丁发的 测试 在线售楼中心
  // http://qmyx.putzip.com/h5/t9?id=136553&psn=20c783740e214d929fe9c893c06bd0c0&refereeopenid=oj3y9wPtClayVSbajzca5k5DJqeY&rscuid=oj3y9wPtClayVSbajzca5k5DJqeY
  qmyx_hope: {
    openid: "oj3y9wGThdLqhn0bZWOj7DeO2Tww",
    passport: "b4de197ab7b03e9d014116821e90d54f",
    flag: 1,
    issubscribe: 1
  },
  qmyx_lgh: {
    openid: "oj3y9wEEApUowGz0hUDx4hbnpHOI",
    passport: "9c453d72980d48face345308b0202fe7",
    flag: 1,
    issubscribe: 1
  },
  qmyx_may: {
    openid: "oj3y9wLPfkK5dkr9rK9i3GyGIXwE",
    passport: "b212d1bb3eb7e5ab971f0a8dcb327829",
    flag: 1,
    issubscribe: 1
  },
  qmyx_dym: {
    // 丁元梦
    openid: "oj3y9wPtClayVSbajzca5k5DJqeY",
    passport: "c929f81258b755b69f91cb202b5a2686",
    flag: 1,
    issubscribe: 1
  },
  rushi_hope: {
    openid: "ooSW7wCba7oABRNDGptiL95zK6Ho",
    passport: "eceb50439b45126f2782d627809c1095",
    flag: 1,
    issubscribe: 1
  },
  yqjisu_hope: {
    openid: "oPg9r1WEa_1ikSKWlMeJonVwQHdQ",
    passport: "70021c7e84e0da8787bab5eb3669590d",
    flag: 1,
    issubscribe: 1
  },
  dtgjbdgy_hope: {
    openid: "o4tq81YTgkV1TMOa2KpNq3y8fc4k",
    passport: "91cd11c31bbc16513b3991dcce7aadb4",
    flag: 1,
    issubscribe: 1
  },
  dtgjbdgy_jarvis: {
    openid: "o4tq81fLPlG8ohlPtC-nwDONAla8",
    passport: "876897184cde3c4d8ae9eb7d86d324cc",
    flag: 1,
    issubscribe: 1
  },
  // http://ysdczj.gbtse.com/h5/t9?id=146763&psn=fdf9a3077df8442984a4efb432f24e49&t=1584685961908
  ysdczj_hope: {
    openid: "oXWALw8HCCZ-icAq_60MI10L7O0Y",
    passport: "2ba737731239e86d7c5db7e55cc531f2",
    flag: 1,
    issubscribe: 1
  },
  // http://localhost:2002/h5/t3?fake=henduoke_hope&id=12175&psn=db28d778733d469b919c9fbfba34e00e&refereeopenid=o3nM05kQIyWliQ0gTd64FDgPNfPM&rscuid=o3nM05hrQmGc8Z-ysAVjvc5QcTkk
  // http://localhost:2002/h5/vcard?fake=henduoke_hope&refereeopenid=o3nM05jR4iRcVfTACSMUXRgErgKk&rscuid=o3nM05jR4iRcVfTACSMUXRgErgKk&from=singlemessage&isappinstalled=0
  // 房友圈链接：
  // https://henduoke.amsova.com/h5/t4?id=154113&psn=3afb6b7b37144f41b746881b19bd2503
  henduoke_hope: {
    openid: "o3nM05jR4iRcVfTACSMUXRgErgKk",
    passport: "246043cfd71f4b1d2058defc1f17e98d",
    flag: 1,
    issubscribe: 1
  },
  henduoke_jarvis: {
    openid: "o3nM05va2wwQvyLtNHYdxRJ4blS8",
    passport: "f31b78b2e1b15535a651920fdbc9faa6",
    flag: 1,
    issubscribe: 1
  },
  henduoke_alpha: {
    openid: "o3nM05ggdhIPeImwwwJE-00WF8yA",
    passport: "b5be7ed77610bae26fb629682701eaa4",
    flag: 1,
    issubscribe: 1
  },
  henduobao_hope: {
    openid: "ozGCqwi1nS-dBe9RUhbqmB48vBQM",
    passport: "a31d046390e57069e8edd22d29dbf77e",
    flag: 1,
    issubscribe: 1
  },
  //   小丁发的 原圈云 在线售楼中心
  // http://yuanquan.gbtse.com/h5/t9?id=135851&psn=ce0dcf55fff94a77aaad653ca8129c35&refereeopenid=om3fus_iem14h8MknDdCgJMC_6ro&rscuid=om3fus_iem14h8MknDdCgJMC_6ro
  yuanquan_hope: {
    openid: "om3fus_cBy12pjP0kqaWLykUDXE4",
    passport: "6db216eb6af85373315d32875a3af2a2",
    flag: 1,
    issubscribe: 1
  },
  yuanquan_may: {
    openid: "om3fusyXtCpZBY8mR39vZr2lPVPA",
    passport: "b4cc7767d4263606c4908135967b9940",
    flag: 1,
    issubscribe: 1
  },
  yuanquan_lyx: {
    openid: "om3fusxpqPI_wsrzsC61Ku2XKjUU",
    passport: "9ea9ebb98a5aac5a075f07330f1163a7"
  },
  yuanquan_zt: {
    openid: "om3fus8Z4XxJI8fBTqIn4Yz8kRuA",
    passport: "37fa6941553136199143f5317b60c927"
  },
  tltjdyfd_hope: {
    openid: "onCAMt55ypjN8aXD4dJMu5USQXEo",
    passport: "449ad7522b171b7420aad551f9612414",
    flag: 1,
    issubscribe: 1
  },
  yuefangy_hope: {
    openid: "olJoa6NKxB8TxW7FWpcKhg1gYvN8",
    passport: "322db2c50695f1bc4365169682fe644a",
    flag: 1,
    issubscribe: 1
  },
  lsst_hope: {
    openid: "orljTwjlQ2MxdBvWg6JfhHQAhX6U",
    passport: "c37d33d9316926ac359a4e60d6e1b319",
    flag: 1,
    issubscribe: 1
  },
  alej_hope: {
    openid: "o3N5ewqRxvPBnm1_ffKz7_mn5dy0",
    passport: "33857cade360243e406dd6b91caae330",
    flag: 1,
    issubscribe: 1
  },
  sshx_hope: {
    openid: "oE_92t2cGkHpIXSGpi1Uys6yqQgI",
    passport: "fc445b3617528f31706605cd972d5a7c",
    flag: 1,
    issubscribe: 1
  },
  hllsq_hope: {
    openid: "oNAw21s_XspqXPzcnnWZDMROVed8",
    passport: "a5847476423a4f86919553b47b648a09",
    flag: 1,
    issubscribe: 1
  },
  // 华发开发环境
  // id=66807&psn=986ab29d236e4011806ae087d8d434da&entry=zxslzx&miniproj=df786c849571438ab0de77b25329e58b&from=sysintro
  hfdev_qmyx_hope: {
    openid: "oU9KX03tr4c0l92nSICJB-lLGDno",
    passport: "042512975eff169c7a84dea5d3089bff",
    flag: 1,
    issubscribe: 1
  },
  hfdev_qmyx_may: {
    openid: "oU9KX02Dv2tVNWoS7jJkgezVDf1Q",
    passport: "4207ecc9addf6fcc66dde23e4d26ce71",
    flag: 1,
    issubscribe: 1
  },
  hfdev_qmyx_cxt: {
    openid: "oU9KX06EsVrM-HIAFPA6xNf5nouk",
    passport: "3ece0e7ac65115ca924c0717ad7e1349",
    flag: 1,
    issubscribe: 1
  },
  hfdev_qmyx_ly: {
    openid: "oU9KX004SG8dJytPBj3RjB_QetZ0",
    passport: "7a41e4258f0446780de3b36f61569573",
    flag: 1,
    issubscribe: 1
  },
  hfdev_qmyx_xm: {
    openid: "oU9KX05WfzAeLNtvKJ_iB0J8atQY",
    passport: "416aacb685b17688b30fb7f50de15c14",
    flag: 1,
    issubscribe: 1
  },
  hfdev_qmyx_hf: {
    openid: "oU9KX00RAY0Qky79HNlw8iEu-8Lo",
    passport: "c8ccb494f14290cf67019a5bd09a194c",
    flag: 1,
    issubscribe: 1
  },
  // id=6689022&psn=c5032859024c47c9a1e1ec6b4bf98dda&entry=zxslzx&miniproj=2a5d9be5d087454bab4c4681e2100558&from=sysintro
  hfdev_hfzyt_hope: {
    openid: "o3v1ft5hUQbqi2-E9hp2idFyF7jU",
    passport: "7bfc43e1229656d76e794a285912623e",
    flag: 1,
    issubscribe: 1
  },
  hfdev_hfzyt_may: {
    openid: "o3v1ftxcJq0j0SOiWfPZvhKRz-IY",
    passport: "289c7655e6b2c9d82921165cdb8dfabf",
    flag: 1,
    issubscribe: 1
  },
  hfdev_qmyx_wj: {
    openid: "oU9KX0w_eBIKPHSWdpgmhMGaW-W8",
    passport: "b3675e0e4454543dc0989657cd578467",
    flag: 1,
    issubscribe: 1
  },
  hfdev_qmyx_hh: {
    openid: "oU9KX0-I4XZ-erhrUooSbBTKgb-4",
    passport: "ff884044927a832c6ae4ee276dcd545c",
    flag: 1,
    issubscribe: 1
  },
  // 珠海华发置业管家 公众号改名为 华发置业通珠海
  hfpro_zhhfzygj_hope: {
    openid: "omkQy0iKw4FYLynp-CXsUSZmBwSI",
    passport: "e8f3ddd0117fa964b120a9296a38e464",
    flag: 1,
    issubscribe: 1
  },
  // 华发南京
  hfpro_zyhfnj_hope: {
    openid: "oDyJbxFSk_1k0RC4D1kA_rKIdKQY",
    passport: "8d998fa0681ae28e25ea59580380a793",
    flag: 1,
    issubscribe: 1
  },
  // 华发江门 https://jmhf.huafamarkting.com/h5/t9?id=66515&psn=6c9e799e503846cabc854fb370d34de1
  hfpro_jmhf_hope: {
    openid: "oWlSZ0-ffMO92Rw6f85iaqX_CaOw",
    passport: "0d469b546ff2bc10db66f541d94b7b3a",
    flag: 1,
    issubscribe: 1
  },
  // 安联e家
  // http://alej.abotz.com/h5/t9?id=144051&psn=dc6e3a1723774a72b7e39e9036d9a14b
  alej_hope: {
    openid: "o3N5ewqRxvPBnm1_ffKz7_mn5dy0",
    passport: "33857cade360243e406dd6b91caae330",
    flag: 1,
    issubscribe: 1
  },
  // 安联e家 陈珺
  alej_chenjun: {
    openid: "o3N5ewvqqeY9eZ-WL4zvc1Z98d4c",
    passport: "8a9caa37477e2d29832a778c8b5ae938",
    flag: 1,
    issubscribe: 1
  },
  // 济南西城置业有限公司
  // http://jnxczy.gdsmcc.com/h5/t9?id=139336&psn=cbac1ea3d61641f197f32b9e54ef6698&refereeopenid=ojgTVt056NWqpUauCWWOLAb9dUDI&rscuid=ojgTVt056NWqpUauCWWOLAb9dUDI&from=groupmessage&isappinstalled=0
  jnxczy_hope: {
    openid: "ojgTVtw9pEOZvrBTiwaH2n6C-eeE",
    passport: "cf0da22de4b27202a5222f6dc6abf30a",
    flag: 1,
    issubscribe: 1
  },
  // 汇龙地产
  // http://hldc.okjedi.com/h5/t9?id=148287&psn=af83d3468be9473c90a1ed80fbe3ce14&refereeopenid=oKqFkwDRc48d15y-jVdLIoAaCKys&from=singlemessage&isappinstalled=0
  hldc_hope: {
    openid: "oKqFkwOhGZXN45wEja_DKn5qQWWc",
    passport: "7cc4b4561ea90c3113b9b58a16954201",
    flag: 1,
    issubscribe: 1
  },
  nbra_gyt: {
    openid: "oqqVDxH8HNMxNBbTB8cLYOGLCYm4",
    passport: "23330defa95de234bd18901ce2c87a28",
    flag: 1,
    issubscribe: 1
  },
  // http://ysdczj.gbtse.com/h5/t9?id=146763&psn=fdf9a3077df8442984a4efb432f24e49&t=1589514610409
  ysdczj_hope: {
    openid: "oXWALw8HCCZ-icAq_60MI10L7O0Y",
    passport: "2ba737731239e86d7c5db7e55cc531f2",
    flag: 1,
    issubscribe: 1
  },
  zpxl_hope: {
    openid: "okSThwXcNFO2UBMevwfN0R3GOK7U",
    passport: "f3eb85225682002e30d2ece30eb12ece",
    flag: 1,
    issubscribe: 1
  },
  alej_zzn: {
    openid: "o3N5ewjmlvR3dFkIGMnCC-LxS_E8",
    passport: "3561cf4904b9b50a6e254a57e889a91f",
    flag: 1,
    issubscribe: 1
  },
  // https://jxwk.gbtse.com/h5/t9?id=143845&psn=ffe97414f507462fbc9fd032407dd32c&t=1582774265742
  jxwk_hope: {
    openid: "oksyjjskJdhHr4BrHeVyOU7VuafQ",
    passport: "99ef4bfb3ed18c8982b778d2b5011dcb",
    flag: 1,
    issubscribe: 1
  },
  // https://lianshi.gbtse.com/h5/t9?id=142614&psn=ec14f21aafae45f088a11e62b5d2b16e
  lianshi_hope: {
    openid: "oAA4e0yNg7mFL_aEAD9J2Ig8XoZo",
    passport: "f1f4567130c5d683b5e5ce184cb57e27",
    flag: 1,
    issubscribe: 1
  },
  // http://shlfsj.abotz.com/h5/t9?id=171187&psn=76654516931f49cb92f99373f608ab15
  shlfsj_hope: {
    openid: "oZBJluCqFCmHKRY6c-yNiWSIUbOE",
    passport: "82a78608c1c460b140417905f0f601fd",
    flag: 1,
    issubscribe: 1
  },
  // http://lzyh.gbtse.com/h5/t9?id=174448&psn=c116821531a446ee8ebfa908e944ade7
  lzyh_hope: {
    openid: "oIgMRw6_VrQ1o11d0bBknvhOfj-E",
    passport: "58a42719cfd9ee02ea4dfe8164ad0858",
    flag: 1,
    issubscribe: 1
  },
  //中海贵阳 顾京
  gyzhys_gj: {
    openid: "oCkbD6IsuA-ArSGvJKGkCoYDm-O0",
    passport: "c0e082a97f981fb963bf1b822f5966f3",
    flag: 1,
    issubscribe: 1
  },
  // https://dfddhhp.okjedi.com/h5/t9?id=178818&psn=ca804a54e176403bb4b4a3ad800e8e26
  dfddhhp_hope: {
    openid: 'o9b-m50N7DxNYestkFy4pZpb85iE', passport: '0e850ae7503e0ff756bf8da3eba97265',
    flag: 1,
    issubscribe: 1
  },
  hltcd_hope: {
    openid: 'ozZFM6YSlX6RmxMKAln_PdvOXNfA', passport: '854e90e82036f1403eb38ee93f342b2a',
    flag: 1,
    issubscribe: 1
  },
  ddhemtyg_hope: {
    openid: 'omLu4twAhjdwFjWERNLIyLrTGjtE', passport: '48cb69359fb06d01b041d449b095ddd4',
    flag: 1,
    issubscribe: 1
  },
  // https://hyhtd.okjedi.com/h5/t9?id=183811&psn=32bb8d8dfe644b6b8258b988dd115eed
  hyhtd_hope: {
    openid: 'olC6MxLy9bMJr-L3rDKp5Gc8cfoQ', passport: '0660ace966b404985c07495b71368754',
    flag: 1,
    issubscribe: 1
  },
  gxjtes_hope: {
    openid: 'o00Mf6WcKJmNQSaPmDhcpxtDU1aY', passport: '975022beb06b929627dbeb2d3bbf4d0e',
    flag: 1,
    issubscribe: 1
  },
  shlfsj_hope: {
    openid: 'oZBJluCqFCmHKRY6c-yNiWSIUbOE', passport: '82a78608c1c460b140417905f0f601fd',
    flag: 1,
    issubscribe: 1
  },
  hsm_hope: {
    openid: 'oH8YP6Rj4wFtTMBGmQ6SKV8RHsRU', passport: '594923c01ce762945e9071e565b354f2',
    flag: 1,
    issubscribe: 1
  },
  // http://xbsjhcws.okjedi.com/h5/t9?id=191935&psn=88b481883dc643988a572317b522ddd8&refereeopenid=oEmBr6e1beap7-aGZx3HLJSEpv_0
  xbsjhcws_hope: {
    openid: 'oEmBr6VzwyXiqwhU43vEVJ8IeDfo', passport: '3a79080e2161dc236ff1bade6b14617d',
    flag: 1,
    issubscribe: 1
  },
  gyzhys_hope: {
    openid: 'oCkbD6Mr6pZQXgdkF2jOHWPkd-9Y', passport: '93b19fbd2959989087605f9d12f0a212',
    flag: 1,
    issubscribe: 1
  },
  alej_test: {
    openid: 'o3N5ewtAkojBnwtvgB3n6VNLhFiY', passport: 'ea0e84b28c14add61a8ea6d63e7ff0b8',
    flag: 1,
    issubscribe: 1
  },
  ajzl_hope: {
    openid: 'oz1o55ipCcMO9nd58veDmvny98R8', passport: '3fbcc08b2bc0bc3152420036ea6e386e',
    flag: 1,
    issubscribe: 1
  }
};


//华发营销配置
let HF_YXCONFIG = {}

let isMp = false;
let url = location.href;
url = url.replace("#wechat_redirect", "")
let tmpObj = {};
let tmpArr = url.split("?");
if (tmpArr.length == 2) {
  let urlParam = tmpArr[1];
  let tmpArr1 = urlParam.split('&');
  tmpArr1 = tmpArr1.map(function (e) {
    tmpObj[e.split('=')[0]] = e.split('=')[1];
  })
}
console.log(tmpObj)
console.log(tmpObj.xcxGzhOpenid, tmpObj.xcxGzhPassport, tmpObj.xcxGzhDomain)
if (tmpObj.openid && tmpObj.passport) {
  Cookies.set("openid", tmpObj.openid, { expires: 30 })
  Cookies.set("passport", tmpObj.passport, { expires: 30 })
  API_DOMAIN = location.hostname.substring(0, location.hostname.indexOf(".")) + ".ttrushi.com";
  // 清除掉链接上的openid和passport
  let urlParam = "";
  Object.keys(tmpObj).forEach(function (e) {
    if (tmpObj[e] && e != 'openid' && e != 'passport') {
      urlParam += `${e}=${tmpObj[e]}&`;
    }
  });
  if (urlParam.length > 0) {
    urlParam = urlParam.substring(0, urlParam.length - 1);
  }
  window.history.replaceState(null, null, urlParam ? ('?' + urlParam) : '');
} else if (tmpObj.xcxGzhOpenid && tmpObj.xcxGzhPassport && tmpObj.xcxGzhDomain) {
  console.log(111)

  API_DOMAIN = tmpObj.xcxGzhDomain + ".ttrushi.com";
  Cookies.set("openid", tmpObj.xcxGzhOpenid, { expires: 30 })
  Cookies.set("passport", tmpObj.xcxGzhPassport, { expires: 30 })
  Cookies.set("fake", `${tmpObj.xcxGzhDomain}_user`, { expires: 30 })
  FAKE_DATA[`${tmpObj.xcxGzhDomain}_user`] = {
    openid: tmpObj.xcxGzhOpenid,
    passport: tmpObj.xcxGzhPassport
  }
  getIsAuth() // 在企业微信中才需要判断
}
else if (isLoc || location.port) {
  if (location.href.indexOf('/h5/qywx/') > -1) {
    // 企业微信的链接
  } else {
    // 本地环境,从fake获取
    (function () {
      // let url = location.href;
      // let tmpObj = {};
      // let tmpArr = url.split("?");
      if (tmpObj.fake) {
        Cookies.set('fake', tmpObj.fake, { expires: 60 * 60 * 1 });
      } else if (Cookies.get('fake')) {
        tmpObj.fake = Cookies.get('fake');
      } else {
        alert("没有url fake参数，也没有cookie fake参数");
      }
      if (tmpObj.fake) {
        if (tmpObj.fake.split("_")[0] == "hfdev") {
          // 华发测试环境
          API_DOMAIN = tmpObj.fake.split("_")[1] + ".huafacrm.com";
          HF_YXCONFIG = {
            api: 'https://sales.test.huafagroup.com/huafa/weixin/agentLogin/getAgentByOpenIdOrTel',
            apiurl: 'https://sales-int.huafagroup.com/huafa/weixin/',
            bs: 'gf',
            appid: 'wx9e5c24514328057c',
            url: 'https://sales.test.huafagroup.com/huafa/weixin/wechat/project/toPageService.html',
            // url: 'https://sales.test.huafagroup.com/huafa/weixin/OnlineSalesWebServlet/doGet',
          }
        } else if (tmpObj.fake.split("_")[0] == "hfpro") {
          // 华发生产环境
          API_DOMAIN = tmpObj.fake.split("_")[1] + ".huafamarkting.com";
          HF_YXCONFIG = {
            api: 'https://sap.huafatech.com/huafa/weixin/agentLogin/getAgentByOpenIdOrTel',
            apiurl: 'https://sap.huafatech.com/huafa/weixin/',
            bs: 'zyzh',
            appid: 'wxf895477b8fc20099',
            url: 'https://sap.huafatech.com/huafa/weixin/wechat/project/toPageService.html',
            // url: 'https://sap.huafatech.com/huafa/weixin/OnlineSalesWebServlet/doGet',
          }
        } else {
          API_DOMAIN = tmpObj.fake.split("_")[0] + ".ttrushi.com";
        }
      } else {
        alert("没有fake参数")
      }
      if (tmpObj.ismp && tmpObj.ismp == "1") {
        isMp = true;
      }
    })();
  }
} else {

  if (location.host.indexOf('huafacrm.com') > -1) {
    // 华发测试环境
    API_DOMAIN = location.hostname.substring(0, location.hostname.indexOf(".")) + ".huafacrm.com";
    HF_YXCONFIG = {
      api: 'https://sales.test.huafagroup.com/huafa/weixin/agentLogin/getAgentByOpenIdOrTel',
      apiurl: 'https://sales-int.huafagroup.com/huafa/weixin/',
      bs: 'gf',
      appid: 'wx9e5c24514328057c',
      url: 'https://sales.test.huafagroup.com/huafa/weixin/wechat/project/toPageService.html',
      // url: 'https://sales.test.huafagroup.com/huafa/weixin/OnlineSalesWebServlet/doGet',
    }
  } else if (location.host.indexOf(".huafamarkting.") > -1 || location.host.indexOf(".rushiai.") > -1) {
    // 华发生产环境
    API_DOMAIN = location.hostname.substring(0, location.hostname.indexOf(".")) + ".huafamarkting.com";
    // 生产暂时还未改
    HF_YXCONFIG = {
      api: 'https://sap.huafatech.com/huafa/weixin/agentLogin/getAgentByOpenIdOrTel',
      apiurl: 'https://sap.huafatech.com/huafa/weixin/',
      bs: 'zyzh',
      appid: 'wxf895477b8fc20099',
      url: 'https://sap.huafatech.com/huafa/weixin/wechat/project/toPageService.html',
      // url: 'https://sap.huafatech.com/huafa/weixin/OnlineSalesWebServlet/doGet',
    }
  } else {
    // 其它
    API_DOMAIN = location.hostname.substring(0, location.hostname.indexOf(".")) + ".ttrushi.com";
  }
}

// 获取用户是走授权进入还是使用的默认openid
function getIsAuth() {
  if (tmpObj.isAuth) {
    Cookies.set("isAuth", tmpObj.isAuth, { expires: 30 })
  }
}


const SUBDOMAIN = API_DOMAIN.substring(0, API_DOMAIN.indexOf("."));//其实是api的subdomain
const API_PROTOCOL = location.protocol;
const API_URL = `${API_PROTOCOL}//${API_DOMAIN}/qc-webapp/wxapi.do`;//如是
const API_URL_H5COUNT = `${API_PROTOCOL}//${API_DOMAIN}/qc-webapp/h5count.do`;//h5 生产环境
const API_URL_HDK = `https://hdk.rstthd.com/api/v1/`;//很多客 生产环境
const API_URL_HDB = `${API_PROTOCOL}//hdk.rstthd.com/henduobao/api/`;//很多宝 生产环境
const API_URL_SL = `${API_PROTOCOL}//hdk.rstthd.com/saleslead/`;//光哥接口 销售线索
// const API_URL_LIVES = `https://qmyx.ttrushi.com/qc-webapp/`; //直播接口
const API_URL_LIVES = `${API_PROTOCOL}//${API_DOMAIN}/qc-webapp/`; //直播接口
const API_URL_GETIP = `${API_PROTOCOL}//${API_DOMAIN}/qc-webapp/openApi/getAreaByIp`;
// const API_URL_GETIP = 'http://qmyx.rushiai.com/qc-webapp/openApi/getAreaByIp';
const API_CHAT = `https://im.ruthus.com`;//聊天接口

const paramKeys = ["openid", "passport", "flag", "appid", "issubscribe"];

let OAUTH_URL = "";
let APPID = "";
let OAUTH_IMG = "";

//微信分享
let SHARE_TITLE = API_DOMAIN.indexOf("henduoke") > -1 ? "很多客" : (API_DOMAIN.indexOf("henduobao") > -1 ? "很多宝" : "");
let SHARE_DESC = API_DOMAIN.indexOf("henduoke") > -1 ? "很多客" : (API_DOMAIN.indexOf("henduobao") > -1 ? "很多宝好文推荐" : "");
let SHARE_TIMELINE_TITLE = "";
let SHARE_LINK = "";
let SHARE_API = "";
let SHARE_IMG_URL = "https://assets.rurushishi.com/activies/ncjg-assistance/phone.png";
let FORUM_PLATE_DATA = null;
let SHARE_CALLBACK_OK = function () { };

const GLOBAL_BASE_PATH = "/h5";

// 小程序配置的域名
const MP_DOMAIN = {
  // downloadFile合法域名
  DOWNLOAD: [
    "https://app.work.weixin.qq.com",
    "https://assets.rurushishi.com",
    "https://assets.wxmp.ruthus.com",
    "https://bang.qq.com",
    "https://finance.qq.com",
    "https://gu.qq.com",
    "https://hdk.rstthd.com",
    "https://mp.weixin.qq.com",
    "https://sticker.weixin.qq.com",
    "https://tcp.tencent.com",
    "https://test.tcp.tencent.com",
    "https://web.wechat.com",
    "https://web1.wechat.com",
    "https://web2.wechat.com",
    "https://work.weixin.qq.com",
    "https://wx.qlogo.cn",
    "https://wx.qq.com",
    "https://wx2.qq.com",
    "https://wx8.qq.com",
    "https://wzq.tenpay.com"
  ],
  // 业务域名
  BUSINESS: [
    "https://henduoke.quanc.com.cn",
    "https://henduoke.rushizhineng.com",
    "https://rushi.rushizhineng.com",
    "https://wxmppage.ruthus.com"
  ],
  BUSINESS_OTHER: {
    taxyzhc: [
      "othermp.ideamake.cn",
      "www.hnmaiwa.com"
    ]
  },
  // 华发置业通 小程序
  BUSINESS_HUAFA: [
    "homtop.cn",
    "huafacrm.com",
    "huafamarkting.com",
    "rushifckj.com",
    "ruthyx.com",
    "sales.test.huafagroup.com",
    "sap.huafatech.com",
    "external.fang.anjuke.com",
    "huafa.ideamake.cn",
    // vr看房 开始
    "infishow.ideamake.cn",
    "img360wcs.soufunimg.com",
    "img360wcs02.fang.com",
    "fengting.io",
    "www.720yuntu.com"
    // vr看房 结束
  ]
};

export default {
  API_DOMAIN,
  HF_YXCONFIG,
  API_URL,
  paramKeys,
  OAUTH_URL,
  APPID,
  FAKE_DATA,
  SHARE_TITLE,
  SHARE_DESC,
  SHARE_TIMELINE_TITLE,
  SHARE_LINK,
  SHARE_API,
  SHARE_IMG_URL,
  SHARE_CALLBACK_OK,
  FORUM_PLATE_DATA,
  GLOBAL_BASE_PATH,
  isDebug,
  API_URL_H5COUNT,
  API_URL_GETIP,
  API_URL_HDK,
  API_URL_HDB,
  isLoc,
  isMp,
  hdkXcxAppId,
  API_URL_SL,
  API_URL_LIVES,
  MP_DOMAIN,
  SUBDOMAIN,
  DOMAIN,
  API_CHAT
};
